<template>
	<div class='media-container'>
		<div class='media_container'>
			<div class='media'
				v-for='(md, m) in media'
				:key='"media"+m'
			>
				<MediaSlot v-model='media[m]'
					v-if="media[m].image"
					:ratio='ratio'
					:ref='`mediaSlot-${m}`'
					@photo-added='addMedia()'>
					<div class='imageWrapper' v-if='media[m].image.src'>
						<img :src='media[m].image.src'>
					</div>
					<div class='msg-container' v-else>
						<div class='msg'>
							<svg class='icon'>
								<use xlink:href='#icon-upload'/>
							</svg>
							<span class='text'>Click to upload</span>
						</div>
					</div>
				</MediaSlot>
				<div class='fileWrapper' v-if='media[m].file'>
					<div class="file-content">
						<svg class='icon'>
							<use v-if="['xls', 'xlsx', 'XLS', 'XLS'].includes(md.file.format)" xlink:href='#icon-file-excel'/>
							<use v-if="['doc', 'docx', 'DOC', 'DOCX'].includes(md.file.format)" xlink:href='#icon-file-word'/>
							<use v-if="['pdf'].includes(md.file.format)" xlink:href='#icon-file-pdf'/>
						</svg>
					</div>
					<p class="file-name" >{{ media[m].file.name }}</p>
					<p class="file-error" >{{ errors[m]}}</p>
				</div>
				<div class='delete-btn' @click='delMdia(m)'>
					<svg class='icon'>
						<use xlink:href='#icon-remove'/>
					</svg>
				</div>
			</div>
		</div>
		<div class='photo' @click='addMedia()' v-if='(media.length <= maxLength && !hideButtonAdd) && media.length<2 '>
			<div class='icon'>
				<svg width='18'
					height='18'
					viewBox='0 0 18 18'
					fill='none'
					xmlns='http://www.w3.org/2000/svg'>
					<path
						d='M2 18H16C16.5304 18 17.0391 17.7893 17.4142 17.4142C17.7893 17.0391 18 16.5304 18 16V2C18 1.46957 17.7893 0.960859 17.4142 0.585786C17.0391 0.210714 16.5304 0 16 0H2C1.46957 0 0.960859 0.210714 0.585786 0.585786C0.210714 0.960859 0 1.46957 0 2V16C0 16.5304 0.210714 17.0391 0.585786 17.4142C0.960859 17.7893 1.46957 18 2 18ZM5 11L7.363 13.363L11 8L16 15H2L5 11Z'
						fill='#54AE32'/>
				</svg>
			</div>
			<div class='photo-text'>
				Add photo
			</div>
		</div>
		<slot></slot>
	</div>
</template>

<script>
import MediaSlot from '__jsVueSections/MediaSlot/MediaSlot.vue';
import EventBus from '__jsEbentBus';

export default {
	name:       'MediaContainer',
	components: {
		MediaSlot
	},
	props: {
		value: {
			type: Array,
			default() {
				return [];
			}
		},
		maxLength: {
			type:    Number,
			default: 5
		},
		page: {
			type:    String,
			default: 'media-container'
		},
		hideButtonAdd: {
			type:    Boolean,
			default: false
		},
		ratio: {
			type: Array,
			default() {
				return [178, 108];
			}
		},
		errors: {
			type: Array,
			default() {
				return [];
			}
		}
	},
	data: function() {
		return {
			media: false,
		};
	},
	created: function() {
		this.media = this.value;
	},
	watch: {
		media: {
			handler(newVal) {
				this.$emit('input', newVal);
			},
			deep: true
		},
		value: function() {
			this.media = this.value;
		}
	},
	methods: {
		addMedia: function() {
			this.media.push({
				id:    false,
				image: {
					src:  false,
					blob: false
				}
			});
			if (this.media.length === 1) {
				setTimeout(() => {
					this.$refs[`mediaSlot-${this.media.length - 1}`][0].openExplorer();
				}, 100);
			}
		},
		delMdia: function(m) {
			var id = this.media[m].id;
			this.media.splice(m, 1);
			this.$emit('delete', id);
		},
	}
};
</script>
